import { render, staticRenderFns } from "./TestCardInfo.vue?vue&type=template&id=5092a674&scoped=true&"
import script from "./TestCardInfo.vue?vue&type=script&lang=js&"
export * from "./TestCardInfo.vue?vue&type=script&lang=js&"
import style0 from "./TestCardInfo.vue?vue&type=style&index=0&id=5092a674&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5092a674",
  null
  
)

export default component.exports